import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Error Boundary Component
 * Catches React rendering errors and displays fallback UI
 */
import React, { Component } from 'react';
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsx("div", { className: "min-h-[200px] flex items-center justify-center p-8", children: _jsxs("div", { className: "text-center", children: [_jsx("h2", { className: "text-lg font-semibold text-red-600 dark:text-red-400 mb-2", children: "Something went wrong" }), _jsx("p", { className: "text-sm text-gray-600 dark:text-gray-400 mb-4", children: this.state.error?.message ?? 'An unexpected error occurred' }), _jsx("button", { onClick: () => this.setState({ hasError: false, error: null }), className: "px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm", children: "Try Again" })] }) }));
        }
        return this.props.children;
    }
}
